import { MMKV } from 'react-native-mmkv'
import { StateStorage } from 'zustand/middleware'

const mmkvStorage = new MMKV()

function saveObject(key: string, value: any) {
  try {
    mmkvStorage.set(key, JSON.stringify(value))
  } catch (error) {
    console.log('failed to save object')
  }
}

function getObject(key: string) {
  try {
    const data = mmkvStorage.getString(key)
    if (data) {
      return JSON.parse(data)
    }
  } catch (error) {
    console.log('failed to get object')
  }
  return null
}

function deleteObject(key: string) {
  try {
    mmkvStorage.delete(key)
  } catch (error) {
    console.log('failed to delete object')
  }
}

function nonAsyncSaveObject(key: string, value: any) {
  mmkvStorage.set(key, JSON.stringify(value))
}

function nonAsyncGetObject(key: string) {
  const data = mmkvStorage.getString(key)
  if (data) {
    return JSON.parse(data)
  }

  return null
}

export const persistStorage: StateStorage = {
  setItem: (name: string, value: string) => {
    return mmkvStorage.set(name, value)
  },
  getItem: (key: string) => {
    const value = mmkvStorage.getString(key)
    return value ?? null
  },
  removeItem: (key: string) => {
    return mmkvStorage.delete(key)
  },
}

const storageUtil = {
  mmkvStorage,
  persistStorage,
  getObject,
  saveObject,
  deleteObject,
  nonAsyncSaveObject,
  nonAsyncGetObject,
}
export default storageUtil
